import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {PipelinesService} from "../../../../pipelines.service";
import {PercentPipe} from "@angular/common";
import {DataFormatService} from "../../../../../services/data-format.service";
import {MatIcon} from "@angular/material/icon";
import {MatTooltip} from "@angular/material/tooltip";

@Component({
  selector: 'pipelines-panel-participants',
  imports: [
    PercentPipe,
    MatIcon,
    MatTooltip
  ],
  templateUrl: './pipelines-panel-participants.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./pipelines-panel-participants.component.scss','../../pipelines-table.component.scss']
})
export class PipelinesPanelParticipantsComponent implements OnInit{
  constructor(private _pipelineService: PipelinesService, public dataFormat: DataFormatService) {
  }
  @Input() detail:any;
  @Input() participantType: string
  public expanded: boolean = false;
  public rows: { label: string; key: string }[][] = [];
  public participantDetail:any;

  public displayCREAParticipantFields: {label: string, key:string} [] = [
    { label: 'Originator', key: 'Originator'},
    { label: 'Asset Manager', key: 'Asset Manager'},
    { label: 'Disposition Associate', key: 'Disposition Associate'},
    { label: 'Account Manager', key: 'Account Manager'},
    { label: 'Underwriter', key: 'Underwriter'},
    { label: 'Legal Reviewer', key: 'Legal Reviewer'},
    { label: 'Closing Coordinator', key: 'Closing Coordinator'},
    { label: 'Underwriting Analyst', key: 'Underwriting Analyst'},
    { label: 'Syndications Lead', key: 'Syndications Lead'},
    { label: 'Acquisition Analyst', key: 'Acquisition Analyst'},
    { label: 'Construction Analyst', key: 'Construction Analyst'},
    { label: 'Tax Reviewer', key: 'Tax Reviewer'},
    { label: 'Senior Asset Manager', key: 'Senior Asset Manager'},
    { label: 'Accounting Reviewer', key: 'Accounting Reviewer'}
  ]

  public displayFundParticipantFields: {label: string, key: string} [] = [
    {label: 'Syndications Account Manager', key: 'Syndications Account Manager'},
    {label: 'Senior Fund Analyst', key: 'Senior Fund Analyst'},
    {label: 'Senior Fund Management SVP', key: 'Senior Fund Management SVP'},
    {label: 'Senior Syndications Analyst', key: 'Senior Syndications Analyst'},
    {label: 'Fund Analyst', key: 'Fund Analyst'},
    {label: 'Syndications Jr Account Manager', key: 'Syndications Jr Account Manager'},
    {label: 'Syndications Analyst', key: 'Syndications Analyst'},
  ]

  public displayThirdPartyFields: {label: string, key: string} [] = [
    {label: 'Accountant', key: 'Accountant'},
    {label: 'CREA Counsel Attorney', key: 'CREA Counsel Attorney'},
    {label: 'General Partner', key: 'General Partner'},
    {label: 'Architect', key: 'Architect'},
    {label: 'Developer', key: 'Developer'},
    {label: 'Guarantor', key: 'Guarantor'},
    {label: 'Box Collaborator', key: 'Box Collaborator'},
    {label: 'Developer Counsel', key: 'Developer Counsel'},
    {label: 'LIHTC Consultant', key: 'LIHTC Consultant'},
    {label: 'Co-Developer', key: 'Co-Developer'},
    {label: 'Dispositions Legal Contact', key: 'Dispositions Legal Contact'},
    {label: 'Market Study Consultant', key: 'Market Study Consultant'},
    {label: 'Compliance Consultant', key: 'Compliance Consultant'},
    {label: 'Dispositions Legal Firm', key: 'Dispositions Legal Firm'},
    {label: 'Property Manager', key: 'Property Manager'},
    {label: 'Construction Consultant', key: 'Construction Consultant'},
    {label: 'Environmental Consultant', key: 'Environmental Consultant'},
    {label: 'Service Provider', key: 'Service Provider'},
    {label: 'Co-Sponsor', key: 'Co-Sponsor'},
    {label: 'Environmental Counsel', key: 'Environmental Counsel'},
    {label: 'Sponsor', key: 'Sponsor'},
    {label: 'CREA Counsel', key: 'CREA Counsel'},
    {label: 'General Contractor', key: 'General Contractor'},
    {label: 'Tenant File Reviewer', key: 'Tenant File Reviewer'}

  ]

  ngOnInit() {
    this.rows = this._formatRows()
    this._formatDetail()
  }

  public toggleExpand(){
    this.expanded = !this.expanded
  }

  private _formatRows(){
    if(this.participantType=='people'){
      return this._pipelineService.splitExpandedRowChunk(this.displayCREAParticipantFields, 3)
    }
    if(this.participantType=='fund'){
      return this._pipelineService.splitExpandedRowChunk(this.displayFundParticipantFields, 3)
    }
    if(this.participantType=='thirdParty'){
      return this._pipelineService.splitExpandedRowChunk(this.displayThirdPartyFields, 3)
    }
    return []
  }

  private _formatDetail(){
      let participants = this.participantType=='fund' ? this._pipelineService.parseField(this.detail.fund_participants) : this.detail.participants
      this.participantDetail = participants?.reduce((acc:any, par:any) => {
        let parObj = {
          name: par.name,
          id: par.entity_id,
          tags: par.tags,
          __typename: par.entity_type == 'people' ? 'Person' : 'Organization'
        }
        const list:any[] = (acc[par.role] ??= []);
        if(!list.includes(parObj)){
          list.push(parObj)
        }
        return acc
      }, {})
  }

  public itemTags(participant:any){
    let string = ''
    participant.tags.forEach((tag:{name: string, id: string}) => {
      if(string.length == 0 || string == ''){
        string = tag.name
      } else {
        string = string + ", " + tag.name
      }
    })
    return string
  }

}
